module.exports = __webpack_public_path__ + "img/quicklycoins-bg.290cf450.png";